<template>
  <div class="content-main">
    <HeaderBar :text="schedule.header" :backgroundUrl="schedule.headerUrl"></HeaderBar>
    <div class="content">
      <div class="container">
        <div class="search-area">
          <div class="header-group">
            <i class="fa fa-search text-right" aria-hidden="true" style="padding: 0 5px;"></i>
            <span>{{ schedule.search[0] }}</span>
            <input class="input" type="text" label="_" v-model="year">
            <span>{{ schedule.search[1] }}</span>
            <input class="input" type="text" label="_" v-model="room">
          </div>
        </div>
        <div class="result-box" v-if="activeResult">
          <div class="result-header text-center">
            <h1>{{schedule.result[0]}} {{year}}{{room}}</h1>
          </div>
          <div class="study">
            <h3>{{ schedule.result[1] }}</h3>
            <div class="result-group">
              <p>[{{ schedule.dataStr[0] }}: 23/02/62] - <a href="#">{{schedule.dataStr[1]}} {{year}} {{schedule.dataStr[2]}} {{room}}</a></p>
            </div>
          </div>
          <div class="exam">
            <h3>{{schedule.result[2]}}</h3>
            <div class="result-group">
              <p>[{{schedule.dataStr[0]}}: 23/02/62] - <a href="#">{{schedule.dataStr[3]}} {{year}}</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../COMMON/HeaderBar'

export default {
  components: {
    HeaderBar
  },
  props: ['schedule'],
  data () {
    return {
      year: '',
      room: '',
      activeResult: false
    }
  },
  methods: {
    onInputChange: function () {
      this.activeResult = (this.year !== '' && this.room !== '')
    }
  },
  watch: {
    year: function (e) {
      if (e.length > 1) {
        e = e[e.length - 1]
      }

      if (e === '4' || e === '5' || e === '6') {
        this.year = e
        this.onInputChange()
      } else {
        this.year = ''
        this.activeResult = false
      }
    },
    room: function (e) {
      if (e.length > 1) {
        e = e[e.length - 1]
      }
      e = e.toUpperCase()

      if (e === 'E' || e === 'S' || e === 'C') {
        this.room = e
        this.onInputChange()
      } else {
        this.room = ''
        this.activeResult = false
      }
    }
  }
}
</script>

<style scoped>
  .content-main {
    padding: 60px 0;
  }

  .content {
    padding: 60px 0;
  }

/* ------------------ Seach Box -------------------- */

  .search-area {
    background-color: #FFA500;
    padding: 30px;
    box-shadow: 0 4px 2px -1px rgba(255, 60, 0, 0.3);
  }

  .header-group span, .header-group input, .header-group .fa {
    font-size: 24px;
    color: #FFF;
  }

  .input {
    border: none;
    background: transparent;
    padding-bottom: 0;
    border-bottom: 2px solid #FFF;
    width: 2em;
    text-align: center;
    line-height: 1;
  }

  .input:focus{
    outline: none;
  }

  @media screen and (max-width: 575px) {
    .search-area {
      padding: 18px;
    }

    .header-group span, .header-group input, .header-group .fa {
      font-size: 18px;
    }

    .input {
      width: 1em;
    }
  }

/* -------------------- Result Box ----------------------*/

  .study, .exam {
    margin-bottom: 30px;
  }

  .result-box {
    padding: 30px;
    border: 0.5px solid rgba(35, 35, 35, 0.4);
    border-top: none;
  }

  .result-box h1, .result-box h3 {
    color: #FFA500;
    margin-bottom: 15px;
  }

  .result-group {
    padding-left: 15px;
  }

  .result-group a:hover {
    border-bottom: 2px solid #FFA500;
  }

</style>



// WEBPACK FOOTER //
// src/components/STUDENTS/Schedule.vue